import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getEmbeds({ commit }) {
      try {
        const response = await api.get('/embeds')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
